import { Splide } from "@splidejs/splide";

export const setupCarousel = () => {
  if (document.querySelector(".home-carousel")) {
    new Splide("#home-carousel", {
      type: "loop",
      autoplay: true,
      speed: 1000,
    }).mount();
  }

  if (document.querySelector(".clinica-carousel")) {
    new Splide("#clinica-carousel", {
      type: "loop",
      autoplay: true,
      speed: 1000,
    }).mount();
  }

  if (document.querySelector(".opinion-carousel")) {
    new Splide("#opinion-carousel", {
      mediaQuery: "min",
      breakpoints: {
        970: {
          destroy: true,
        },
      },
    }).mount();
  }

  if (document.querySelector(".consumo-carousel")) {
    new Splide("#consumo-carousel", {
      mediaQuery: "min",
      breakpoints: {
        970: {
          destroy: true,
        },
      },
      gap: 15,
      arrows: true,
    }).mount();
  }

  if (document.querySelector(".packaging-carousel")) {
    new Splide("#packaging-carousel", {
      mediaQuery: "min",
      breakpoints: {
        970: {
          destroy: true,
        },
      },
      gap: 15,
      arrows: true,
    }).mount();
  }

  if (document.querySelector(".novedades-carousel")) {
    new Splide("#novedades-carousel", {
      mediaQuery: "min",
      breakpoints: {
        970: {
          destroy: true,
        },
      },
      gap: 15,
      arrows: true,
    }).mount();
  }

  if (document.querySelector(".eventos-carousel")) {
    new Splide("#eventos-carousel", {
      gap: 15,
    }).mount();
  }

  if (document.body.classList.contains("producto-single")) {
    new Splide("#mas-leidas-carousel", {
      mediaQuery: "min",
      breakpoints: {
        970: {
          destroy: true,
        },
      },
      gap: 15,
      arrows: true,
      type: "loop",
      clones: 0,
    }).mount();
  }

  if (document.body.classList.contains("ebook-single")) {
    new Splide("#relacionados-carousel", {
      mediaQuery: "min",
      breakpoints: {
        970: {
          destroy: true,
        },
      },
      gap: 15,
      arrows: false,
    }).mount();
  }
};
